export const API_SUCCESS_CODE = 'OK'

export const API_RESPONSE_MESSAGES = {
  OK: '请求成功',
  BAD_REQUEST: '请求参数、字段值或当前业务状态不符合要求',
  UNAUTHORIZED: '未登录或登录已过期',
  FORBIDDEN: '没有权限访问或操作当前资源',
  INTERNAL_ERROR: '服务器发生未预期的系统异常',
  PASSWORD_CHANGE_REQUIRED: '当前账号必须修改密码后才能继续访问',
  LOGIN_TEMPORARILY_LOCKED: '连续登录失败次数过多，账号已被临时锁定',
  AI_ACTIVE_TASK_LIMIT_EXCEEDED: '当前正在处理的 AI 任务数量已达到上限',
  POINT_ACCOUNT_NOT_FOUND: '会员积分账户不存在',
  POINT_TRANSACTION_NOT_FOUND: '积分交易记录不存在',
  POINT_RESERVATION_NOT_FOUND: '积分冻结记录不存在',
  POINT_RESERVATION_STATE_INVALID: '积分冻结记录当前状态不允许执行该操作',
  POINT_ACCOUNT_INCONSISTENT: '积分账户余额与冻结记录等数据不一致',
  POINT_AMOUNT_INVALID: '积分数量或积分业务相关参数不合法',
  POINT_BALANCE_INSUFFICIENT: '会员可用积分余额不足',
  POINT_REQUEST_DUPLICATE: '相同积分请求号及相同业务内容已经处理过',
  POINT_REQUEST_CONFLICT: '积分请求号已被使用，但本次业务内容与原请求不一致',
  POINT_NOTE_VERSION_CONFLICT: '积分流水说明已被其他操作修改，请刷新后重试',
} as const

export type ApiResponseCode = keyof typeof API_RESPONSE_MESSAGES

export function getApiResponseMessage(code: string | undefined, message: string | undefined, fallback = '请求失败') {
  if (message?.trim()) return message
  if (code && code in API_RESPONSE_MESSAGES) return API_RESPONSE_MESSAGES[code as ApiResponseCode]
  return fallback
}
